<template>
  <div class="slider-container">
    <!-- <button 
      class="slider-btn prev-btn" 
      @click="slide(-1)"
      :disabled="currentIndex === 0"
      aria-label="Previous"
    >
      <svg viewBox="0 0 24 24" width="24" height="24">
        <path d="M15.41 16.59L10.83 12l4.58-4.59L14 6l-6 6 6 6 1.41-1.41z"/>
      </svg>
    </button> -->
    
    <div class="slider-wrapper" ref="sliderWrapper">
      <div 
        class="slider-content" 
        :style="{ transform: `translateX(-${currentIndex * itemWidth}px)` }"
        ref="sliderContent"
      >
        <slot></slot>
      </div>
    </div>
    
    <!-- <button 
      class="slider-btn next-btn" 
      @click="slide(1)"
      :disabled="isEndOfSlider"
      aria-label="Next"
    >
      <svg viewBox="0 0 24 24" width="24" height="24">
        <path d="M8.59 16.59L13.17 12 8.59 7.41 10 6l6 6-6 6-1.41-1.41z"/>
      </svg>
    </button> -->
  </div>
</template>

<script>
export default {
  name: 'Slider',
  props: {
    visibleItems: {
      type: Number,
      default: 4
    }
  },
  data() {
    return {
      currentIndex: 0,
      itemWidth: 0,
      totalItems: 0,
      maxIndex: 0
    }
  },
  computed: {
    isEndOfSlider() {
      return this.currentIndex >= this.maxIndex;
    }
  },
  mounted() {
    this.calculateDimensions();
    window.addEventListener('resize', this.calculateDimensions);
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.calculateDimensions);
  },
  methods: {
    calculateDimensions() {
      if (this.$refs.sliderContent && this.$refs.sliderContent.children.length > 0) {
        const firstItem = this.$refs.sliderContent.children[0];
        this.itemWidth = firstItem.offsetWidth;
        this.totalItems = this.$refs.sliderContent.children.length;
        this.maxIndex = Math.max(this.totalItems - this.visibleItems, 0);
      }
    },
    slide(direction) {
      const newIndex = this.currentIndex + direction;
      if (newIndex >= 0 && newIndex <= this.maxIndex) {
        this.currentIndex = newIndex;
      }
    }
  }
}
</script>

<style scoped>
.slider-container {
  display: flex;
  align-items: center;
  position: relative;
  width: 100%;
  overflow: hidden;
}

.slider-wrapper {
  flex: 1;
  overflow: hidden;
}

.slider-content {
  display: flex;
  justify-content: space-between;
  transition: transform 0.3s ease;
  will-change: transform;
  padding: 10px;
}

.slider-btn {
  background: none;
  border: none;
  cursor: pointer;
  padding: 8px;
  margin: 0 10px;
  border-radius: 50%;
  background-color: #f0f0f0;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: background-color 0.2s;
}

.slider-btn:hover {
  background-color: #e0e0e0;
}

.slider-btn:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.slider-btn svg {
  fill: #409eff;
}
</style>